import { watch } from 'vue'
import { useCurrentPropertyId } from './use-current-property-id'
import type { PropertyType } from '@/interfaces'
import { selectableProperties } from '@/utils/displayable-property'

export const usePopulateCurrentPropertyId = (properties: {
  value: PropertyType[] | undefined
}) => {
  const { currentPropertyId } = useCurrentPropertyId()

  watch(
    () => properties.value,
    (allProperties) => {
      if (!allProperties || allProperties.length === 0) return

      const selectable = selectableProperties(allProperties)

      const currentId = currentPropertyId.value
      const isValid =
        typeof currentId === 'number' &&
        selectable.some((p) => p.id === currentId)

      if (!isValid) {
        currentPropertyId.value = selectable[0].id
      }
    },
    { immediate: true }
  )

  return { currentPropertyId }
}
